/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: Date | string; output: Date | string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date | string; output: Date | string; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: number; output: number; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
};

export type AdminAcquiringActionType =
  | 'admin'
  | 'order'
  | 'refill';

export type AdminAcquiringBalanceLog = {
  __typename?: 'AdminAcquiringBalanceLog';
  actionType: AdminAcquiringActionType;
  amount: Scalars['NonNegativeFloat']['output'];
  created: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  projectName: Scalars['String']['output'];
  transactionType: AdminAcquiringTransactionType;
};

export type AdminAcquiringNetworkType =
  | 'ton'
  | 'tron';

export type AdminAcquiringOrder = {
  __typename?: 'AdminAcquiringOrder';
  amount: Scalars['NonNegativeFloat']['output'];
  created: Scalars['DateTime']['output'];
  customId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  operationId: Scalars['String']['output'];
  projectId: Scalars['UUID']['output'];
  projectName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  steamLogin: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type AdminAcquiringProject = {
  __typename?: 'AdminAcquiringProject';
  balance: Scalars['NonNegativeFloat']['output'];
  balanceLogs?: Maybe<Array<AdminAcquiringBalanceLog>>;
  commission: Scalars['NonNegativeFloat']['output'];
  graphAmountDay?: Maybe<Array<AmountDay>>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  network?: Maybe<AdminAcquiringNetworkType>;
  orders?: Maybe<Array<AdminAcquiringOrder>>;
  refills?: Maybe<Array<AdminAcquiringRefill>>;
  secret: Scalars['String']['output'];
  wallet?: Maybe<Scalars['String']['output']>;
};

export type AdminAcquiringRefill = {
  __typename?: 'AdminAcquiringRefill';
  amount: Scalars['NonNegativeFloat']['output'];
  amountRefilled: Scalars['NonNegativeFloat']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  projectName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  status: Scalars['String']['output'];
  txId: Scalars['String']['output'];
  txTs: Scalars['DateTime']['output'];
};

export type AdminAcquiringTransactionType =
  | 'credit'
  | 'debit';

export type AdminOrder = {
  __typename?: 'AdminOrder';
  amount: Scalars['NonNegativeFloat']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  paygateName: Scalars['String']['output'];
  paygateProvider: Scalars['String']['output'];
  paygateUrl?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  type: OrderType;
  uuid: Scalars['UUID']['output'];
};

export type AdminSiteSettings = {
  __typename?: 'AdminSiteSettings';
  commission: Scalars['Float']['output'];
  infoMessage?: Maybe<Scalars['String']['output']>;
  mainTab: OrderType;
  skins: AdminTypeSettings;
  steam: AdminTypeSettings;
};

export type AdminTypeSettings = {
  __typename?: 'AdminTypeSettings';
  amounts: Array<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type AdminTypeSettingsInput = {
  amounts?: InputMaybe<Array<Scalars['Int']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AmountDay = {
  __typename?: 'AmountDay';
  amount: Scalars['NonNegativeFloat']['output'];
  date: Scalars['Date']['output'];
};

export type AuthProvider =
  | 'steam'
  | 'telegram'
  | 'vk';

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type ErrorCodes =
  | 'INTERNAL_SERVER_ERROR'
  | 'INVALID_AMOUNT'
  | 'INVALID_PROVIDER'
  | 'INVALID_STEAM_LOGIN'
  | 'ORDER_NOT_FOUND'
  | 'PROVIDER_NOT_FOUND'
  | 'RATE_LIMIT_EXCEEDED'
  | 'TEMPORARY_UNAVAILABLE'
  | 'UNAUTHORIZED';

export type ErrorExtensions = {
  __typename?: 'ErrorExtensions';
  code: ErrorCodes;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAdminAcquiringProject: AdminAcquiringProject;
  createOrder: Order;
  editAdminAcquiringProject: AdminAcquiringProject;
  logout: Scalars['Boolean']['output'];
  newSecretAdminAcquiringProject: AdminAcquiringProject;
  oAuthSignIn: Scalars['String']['output'];
  updateAdminSiteSettings: AdminSiteSettings;
};


export type MutationCreateAdminAcquiringProjectArgs = {
  commission: Scalars['NonNegativeFloat']['input'];
  name: Scalars['String']['input'];
  network?: InputMaybe<AdminAcquiringNetworkType>;
  wallet?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOrderArgs = {
  amount: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  posthogUUID?: InputMaybe<Scalars['UUID']['input']>;
  providerId: Scalars['Int']['input'];
  type: OrderType;
  yclid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditAdminAcquiringProjectArgs = {
  commission?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<AdminAcquiringNetworkType>;
  wallet?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNewSecretAdminAcquiringProjectArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationOAuthSignInArgs = {
  provider: AuthProvider;
};


export type MutationUpdateAdminSiteSettingsArgs = {
  commission?: InputMaybe<Scalars['Float']['input']>;
  infoMessage?: InputMaybe<Scalars['String']['input']>;
  mainTab?: InputMaybe<OrderType>;
  skins?: InputMaybe<AdminTypeSettingsInput>;
  steam?: InputMaybe<AdminTypeSettingsInput>;
};

export type Order = {
  __typename?: 'Order';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  paygateUrl?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  type: OrderType;
  uuid: Scalars['UUID']['output'];
};

export type OrderStatus =
  | 'created'
  | 'failed'
  | 'finished'
  | 'processing';

export type OrderType =
  | 'skins'
  | 'steam';

export type Query = {
  __typename?: 'Query';
  adminAcquiringBalance: Scalars['NonNegativeFloat']['output'];
  adminAcquiringBalanceLogs: Array<AdminAcquiringBalanceLog>;
  adminAcquiringOrders: Array<AdminAcquiringOrder>;
  adminAcquiringProject: AdminAcquiringProject;
  adminAcquiringProjects: Array<AdminAcquiringProject>;
  adminAcquiringRefills: Array<AdminAcquiringRefill>;
  adminOrders: Array<AdminOrder>;
  adminSiteSettings: AdminSiteSettings;
  order: Order;
  orders: Array<Order>;
  publicOrders: Array<PublicOrder>;
  siteSettings: SiteSettings;
  user?: Maybe<User>;
};


export type QueryAdminAcquiringBalanceLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAdminAcquiringOrdersArgs = {
  customId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operationId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  steamLogin?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAcquiringProjectArgs = {
  id: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminAcquiringRefillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAdminOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SiteSettings = {
  __typename?: 'SiteSettings';
  commission: Scalars['Float']['output'];
  infoMessage?: Maybe<Scalars['String']['output']>;
  mainTab: OrderType;
  ordersCount: Scalars['Int']['output'];
  skins: SkinsSettings;
  steam: SteamSettings;
};

export type SkinsSettings = {
  __typename?: 'SkinsSettings';
  amounts: Array<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  providers: Array<PaymentProvider>;
};

export type SteamSettings = {
  __typename?: 'SteamSettings';
  amounts: Array<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  providers: Array<PaymentProvider>;
};

export type Subscription = {
  __typename?: 'Subscription';
  orderUpdated: Order;
  publicOrderCreated: PublicOrder;
  siteSettingsUpdated: SiteSettings;
  userUpdated: User;
};

export type User = {
  __typename?: 'User';
  admin?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<AuthProvider>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type PaymentProvider = {
  __typename?: 'paymentProvider';
  commission: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicOrder = {
  __typename?: 'publicOrder';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Scalars['String']['output'];
  type: OrderType;
};

export type OrderFragmentFragment = { __typename?: 'Order', id: number, uuid: string, type: OrderType, paygateUrl?: string | null, amount: number, status: OrderStatus, createdAt: Date | string, identifier: string };

export type OrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: number, uuid: string, type: OrderType, paygateUrl?: string | null, amount: number, status: OrderStatus, createdAt: Date | string, identifier: string }> };

export type OrderQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: number, uuid: string, type: OrderType, paygateUrl?: string | null, amount: number, status: OrderStatus, createdAt: Date | string, identifier: string } };

export type PublicOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicOrdersQuery = { __typename?: 'Query', publicOrders: Array<{ __typename?: 'publicOrder', type: OrderType, identifier: string, amount: number, createdAt: Date | string }> };

export type CreateOrderMutationVariables = Exact<{
  type: OrderType;
  identifier: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  providerId: Scalars['Int']['input'];
  posthogUUID?: InputMaybe<Scalars['UUID']['input']>;
  yclid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id: number, uuid: string, type: OrderType, paygateUrl?: string | null, amount: number, status: OrderStatus, createdAt: Date | string, identifier: string } };

export type OrderUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderUpdatedSubscription = { __typename?: 'Subscription', orderUpdated: { __typename?: 'Order', id: number, uuid: string, type: OrderType, paygateUrl?: string | null, amount: number, status: OrderStatus, createdAt: Date | string, identifier: string } };

export type SiteSettingsFragmentFragment = { __typename?: 'SiteSettings', commission: number, mainTab: OrderType, ordersCount: number, infoMessage?: string | null, steam: { __typename?: 'SteamSettings', enabled: boolean, amounts: Array<number>, providers: Array<{ __typename?: 'paymentProvider', id: number, name: string, description?: string | null, logo: string, commission: number }> }, skins: { __typename?: 'SkinsSettings', enabled: boolean, amounts: Array<number> } };

export type SiteSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', commission: number, mainTab: OrderType, ordersCount: number, infoMessage?: string | null, steam: { __typename?: 'SteamSettings', enabled: boolean, amounts: Array<number>, providers: Array<{ __typename?: 'paymentProvider', id: number, name: string, description?: string | null, logo: string, commission: number }> }, skins: { __typename?: 'SkinsSettings', enabled: boolean, amounts: Array<number> } } };

export type SiteSettingsUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SiteSettingsUpdatedSubscription = { __typename?: 'Subscription', siteSettingsUpdated: { __typename?: 'SiteSettings', commission: number, mainTab: OrderType, ordersCount: number, infoMessage?: string | null, steam: { __typename?: 'SteamSettings', enabled: boolean, amounts: Array<number>, providers: Array<{ __typename?: 'paymentProvider', id: number, name: string, description?: string | null, logo: string, commission: number }> }, skins: { __typename?: 'SkinsSettings', enabled: boolean, amounts: Array<number> } } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', uuid?: string | null, provider?: AuthProvider | null, balance?: number | null, username?: string | null } | null };

export type OAuthSignInMutationVariables = Exact<{
  provider: AuthProvider;
}>;


export type OAuthSignInMutation = { __typename?: 'Mutation', oAuthSignIn: string };

export const OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paygateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<OrderFragmentFragment, unknown>;
export const SiteSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"steam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}},{"kind":"Field","name":{"kind":"Name","value":"providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTab"}},{"kind":"Field","name":{"kind":"Name","value":"ordersCount"}},{"kind":"Field","name":{"kind":"Name","value":"infoMessage"}}]}}]} as unknown as DocumentNode<SiteSettingsFragmentFragment, unknown>;
export const OrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paygateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paygateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const PublicOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<PublicOrdersQuery, PublicOrdersQueryVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posthogUUID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yclid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"posthogUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posthogUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"yclid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yclid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paygateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const OrderUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrderUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paygateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}}]}}]} as unknown as DocumentNode<OrderUpdatedSubscription, OrderUpdatedSubscriptionVariables>;
export const SiteSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"steam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}},{"kind":"Field","name":{"kind":"Name","value":"providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTab"}},{"kind":"Field","name":{"kind":"Name","value":"ordersCount"}},{"kind":"Field","name":{"kind":"Name","value":"infoMessage"}}]}}]} as unknown as DocumentNode<SiteSettingsQuery, SiteSettingsQueryVariables>;
export const SiteSettingsUpdatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SiteSettingsUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteSettingsUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SiteSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"steam"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}},{"kind":"Field","name":{"kind":"Name","value":"providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"amounts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainTab"}},{"kind":"Field","name":{"kind":"Name","value":"ordersCount"}},{"kind":"Field","name":{"kind":"Name","value":"infoMessage"}}]}}]} as unknown as DocumentNode<SiteSettingsUpdatedSubscription, SiteSettingsUpdatedSubscriptionVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const OAuthSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OAuthSignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthProvider"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oAuthSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}]}]}}]} as unknown as DocumentNode<OAuthSignInMutation, OAuthSignInMutationVariables>;